import React from "react";
import {
  Wrapper,
  HeroWrapper,
  PlanSection,
  TimelineChartWrapper,
  TimelineSectionRow,
  TrendAndTreemapWrapper,
  BarChartCard,
  TreemapCard,
  ChartSkeleton,
  ChartSkeletonTitle,
  ChartSkeletonBody,
  SkeletonBox,
} from "../styles";
import { PlanSkeletonGrid } from "./PlanSkeletonGrid";

export const FinancesSkeleton: React.FC = () => {
  return (
    <Wrapper
      aria-label="Loading financial dashboard"
      aria-live="polite"
      aria-busy="true"
    >
      <HeroWrapper>
        <SkeletonBox
          style={{
            height: "160px",
            width: "100%",
            borderRadius: "16px",
            opacity: 1,
          }}
        />
      </HeroWrapper>

      <TimelineSectionRow>
        <TimelineChartWrapper>
          <ChartSkeleton>
            <ChartSkeletonTitle />
            <ChartSkeletonBody height={400} />
          </ChartSkeleton>
        </TimelineChartWrapper>
      </TimelineSectionRow>

      <PlanSection>
        <PlanSkeletonGrid />
      </PlanSection>

      <TrendAndTreemapWrapper>
        <BarChartCard>
          <ChartSkeletonBody height={350} />
        </BarChartCard>
        <TreemapCard>
          <ChartSkeletonBody height={350} />
        </TreemapCard>
      </TrendAndTreemapWrapper>
    </Wrapper>
  );
};
